var isMobile = false;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
}
var gee = gee || $.fn.gene;
gee.hook('bottomFixed', function ($obj) {
    var obj_pos = $obj.position().top + $obj.height();
    lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st < lastScrollTop) {
            $obj.css('position', 'fixed').css('bottom', '0').css('z-index', 99);
        } else {
            $obj.css('position', 'relative').css('z-index', 999);
        }
        lastScrollTop = st;
    });
});
gee.hook('carouselHeight', function (me) {
    if ($(window).width() < 768 || isMobile == true) {
        $(".main-carousel-right").css('height', ($('.main-carousel-right').find('.item').height() + 10) * 3);
    } else {
        // $("#carousel-sub").css('height', $('.main-carousel-left').height());
        $(".main-carousel-right").css('height', $('.main-carousel-left').height());
    }
    console.log($("#carousel-sub").height());
});
gee.hook('modal', function (me) {
    $(me.data('target')).modal('show');
});

gee.hook('linkModal', function (me) {
    $(me.data('target')).modal('show')
    $(me.data('target'))
        .find('.loc').html(me.data('label')).end()
        .find('.btn-url').attr("href", me.data('url')).end()
        .removeClass('en tw ko cn')
        .addClass(me.data('slug')).end()
});


$(window).resize(function () {
    gee.carouselHeight();
});
(function ($) {
    gee.debug = 1;
    gee.init();
    var Sage = {
        // All pages
        'common': {
            init: function () {
                if ($(window).width() < 768 || isMobile == true) {
                    $('.dropdown-toggle').dropdown();
                }
                $('select[name="country"]').change(function () {
                    if (this.value == 0) { };
                });
                $(".row-eq-height").each(function () {
                    var heights = $(this).find(".col-eq-height").map(function () {
                        return $(this).outerHeight();
                    }).get(),
                        maxHeight = Math.max.apply(null, heights);
                    $(this).find(".col-eq-height").outerHeight(maxHeight);
                });
                $("input.input-spinner").TouchSpin({
                    min: 0,
                    max: 100,
                    step: 1
                });
            },
            finalize: function () { }
        },
        'home': {
            init: function () {
                gee.carouselHeight();
                var carousel_main = new Swiper('#carousel-main', {
                    slidesPerView: 'auto',
                    autoplay: 3000,
                    pagination: '#carousel-main .swiper-pagination',
                });
                var carousel_sub = new Swiper('#carousel-sub', {
                    direction: 'vertical',
                    slidesPerView: 3,
                    spaceBetween: 10,
                    autoplay: 3000,
                });
                var slidesPerView;
                var breakpoints = {};
                $('.slider').each(function (index, element) {
                    $(this).addClass('swiper' + index);
                    switch (index) {
                        case 0:
                            slidesPerView = 4;
                            breakpoints = {
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 30
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 30
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20
                                },
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 0
                                }
                            };
                            break;
                        case 1:
                            slidesPerView = 5;
                            breakpoints = {
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 10
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 10
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20
                                },
                                320: {
                                    slidesPerView: 2,
                                    spaceBetween: 10
                                }
                            };
                            break;
                        default:
                            slidesPerView = 5;
                            breakpoints = {
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 100
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 30
                                },
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 20
                                },
                                320: {
                                    slidesPerView: 2,
                                    spaceBetween: 10
                                }
                            }
                    }
                    $('.swiper' + index).swiper({
                        paginationClickable: true,
                        pagination: '.swiper' + index + ' .swiper-pagination',
                        paginationClickable: true,
                        slidesPerView: slidesPerView,
                        spaceBetween: 30,
                        grabCursor: true,
                        preventClicks: false,
                        autoplay: 3000,
                        watchSlidesVisibility: true,
                        breakpoints: breakpoints
                    });
                });
            },
            finalize: function () { }
        },
        'product': {
            init: function () {
                if (isMobile) {
                    $('#product-description').removeClass('in');
                }
                $('.slider').swiper({
                    paginationClickable: true,
                    pagination: '.slider .swiper-pagination',
                    paginationClickable: true,
                    slidesPerView: 5,
                    grabCursor: true,
                    preventClicks: false,
                    autoplay: 3000,
                    spaceBetween: 30,
                    watchSlidesVisibility: true,
                    breakpoints: {
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 40
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        }
                    }
                });
            },
            finalize: function () { }
        },
        'products': {
            init: function () {
                $('.slider').swiper({
                    paginationClickable: true,
                    pagination: '.slider .swiper-pagination',
                    paginationClickable: true,
                    slidesPerView: 5,
                    spaceBetween: 30,
                    grabCursor: true,
                    preventClicks: false,
                    autoplay: 3000,
                    watchSlidesVisibility: true,
                    breakpoints: {
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 40
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        320: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        }
                    }
                });
            },
            finalize: function () { }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
